(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9915],{

/***/ 78299:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/data-stores",
      function () {
        return __webpack_require__(65450);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var theme_sub_menu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66084);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99408);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15313);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var redux_api_action_filters__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93103);
/* harmony import */ var redux_api_reselect_filters__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45257);
/* harmony import */ var redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95293);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32016);









function AnalyticsSubMenu(param) {
    var activeKey = param.activeKey;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(), push = ref.push, query = ref.query;
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(redux_api_reselect_filters__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), dataType = ref1.dataType, compare = ref1.compare, dateRange = ref1.dateRange, dateFrom = ref1.dateFrom, dateTo = ref1.dateTo, filters = ref1.filters, terms = ref1.terms, filtersData = ref1.filtersData, termsData = ref1.termsData;
    var ref2 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), _payload = ref2.payload, company = _payload.company, analytics_type = _payload.analytics_type, hasPROPlan = _payload.hasPROPlan;
    var handleDataTypeChange = function(dataType) {
        return function() {
            dispatch((0,redux_api_action_filters__WEBPACK_IMPORTED_MODULE_8__/* .changeDataTypeFilter */ .u2)(dataType));
            dispatch((0,redux_api_action_filters__WEBPACK_IMPORTED_MODULE_8__/* .resetChanged */ .VS)());
            var newQuery = {
                compare: encodeURI(compare),
                dataType: encodeURI(dataType),
                dateRange: encodeURI(dateRange),
                dateFrom: encodeURI(dateFrom),
                dateTo: encodeURI(dateTo),
                filters: encodeURI(filters),
                terms: encodeURI(terms),
                filtersData: encodeURI(filtersData),
                termsData: encodeURI(termsData)
            };
            push({
                pathname: "/analytics",
                query: newQuery
            });
        };
    };
    var options = [
        {
            key: "panoramic",
            title: (analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/i)) ? translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].trend : translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].revenues,
            onClick: handleDataTypeChange((analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/i)) ? "temporary_data" : "aggregated_data"),
            color: "primary_300"
        },
        {
            key: "usage",
            title: translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].usage,
            onClick: handleDataTypeChange("usage_data")
        },
        {
            key: "data-stores",
            title: translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode]["Data & Stores"],
            href: "/analytics/data-stores"
        }, 
    ];
    if (analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/i)) {
        options.splice(1, 0, {
            key: "confirmed",
            title: translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].realdata,
            onClick: handleDataTypeChange("real_data"),
            color: "primary_300"
        });
    }
    if (company && (company === null || company === void 0 ? void 0 : company.code) === "SL_US" && !hasPROPlan) options.push({
        key: "upgradeToPro",
        title: translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].upgradeToPro,
        href: "https://www.streetlib.com/pricing/",
        color: "orange_400"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_sub_menu__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        activeKey: dataType !== "usage_data" ? activeKey : "usage",
        options: options
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AnalyticsSubMenu);


/***/ }),

/***/ 32095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15313);
/* harmony import */ var redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95293);




function TopBar() {
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var customerType = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).customerType;
    return languageCode === "REMOVED" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "sl-top-bar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "sl-top-bar-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sl-top-bar-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Su Ready sconto del 20% su tutti i servizi editoriali, approfittane subito! Promo valida fino a venerd\xec 18 novembre 2022"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sl-top-bar-actions",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://readybooks.io",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "Vai su Ready"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TopBar);


/***/ }),

/***/ 42805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ warning_notification; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/redux/action/warning.js
var warning = __webpack_require__(6482);
// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/redux/reselect/warning.js
var reselect_warning = __webpack_require__(97998);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/icons/alert.js
var icons_alert = __webpack_require__(88176);
;// CONCATENATED MODULE: ./src/theme/icons/hide.js


function Hide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.05475 7.50925L2.159 4.6135C1.019 5.85625 0.587 7.10125 0.5795 7.12675L0.5 7.36375L0.57875 7.60075C0.59525 7.651 2.31575 12.6137 8.0405 12.6137C8.73725 12.6137 9.37175 12.5372 9.9545 12.409L7.895 10.3495C7.15346 10.3131 6.45196 10.0022 5.92699 9.47726C5.40201 8.95228 5.0911 8.25078 5.05475 7.50925ZM8.0405 2.11375C6.64925 2.11375 5.50925 2.41675 4.559 2.86225L1.78025 0.0834961L0.71975 1.144L14.2197 14.644L15.2803 13.5835L12.8068 11.11C14.7853 9.64525 15.491 7.63225 15.5015 7.60075L15.5802 7.36375L15.5015 7.12675C15.485 7.0765 13.7653 2.11375 8.0405 2.11375ZM9.47 7.77324C9.61025 7.26549 9.491 6.694 9.101 6.30325C8.711 5.9125 8.13875 5.794 7.631 5.93425L6.5 4.80325C6.96347 4.51823 7.49641 4.36619 8.0405 4.36375C9.695 4.36375 11.0405 5.70925 11.0405 7.36375C11.0383 7.90773 10.8859 8.44055 10.6003 8.9035L9.47 7.77324Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var hide = (Hide);

// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/components/warning-notification/index.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: ",
        ";\n  width: 100%;\n  border-radius: 12px;\n\n  & > .head {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    & > div {\n      display: flex;\n      flex-direction: row;\n    }\n\n    & > div > span {\n      color: ",
        ";\n    }\n  }\n\n  & > .notification {\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    border-left: 4px solid ",
        ";\n    padding: ",
        "px;\n    margin: ",
        "px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ef63db-0"
})(_templateObject(), index_esm/* space */.Dh, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
}, (0,dist_index_esm/* themeGet */.R)("colors.warning"), (0,dist_index_esm/* themeGet */.R)("colors.accent"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.warning"), (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("space.xs"));
function WarningNotification(param) {
    var style = param.style, className = param.className;
    var dispatch = (0,es/* useDispatch */.I0)();
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isVisible = (0,es/* useSelector */.v9)(function(state) {
        return state.warning;
    }).isVisible;
    var warnings = (0,es/* useSelector */.v9)(reselect_warning/* default */.Z);
    (0,react.useEffect)(function() {
        dispatch((0,warning/* getWarningRequest */.jT)());
    }, [
        dispatch
    ]);
    var handleClose = (0,react.useCallback)(function() {
        dispatch((0,warning/* setWarningVisible */.Ic)(false));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isVisible: isVisible && warnings.length
    }, style), {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_alert/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h4",
                                lineHeight: "h4",
                                fontWeight: "bold",
                                color: "grey_600",
                                ml: "10px",
                                children: translations/* default */.Z[languageCode].warning
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: translations/* default */.Z[languageCode].warning,
                        type: "button",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hide, {})
                    })
                ]
            }),
            warnings.map(function(param) {
                var key = param.key, message = param.message;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "notification",
                    children: message
                }, key);
            })
        ]
    }));
}
/* harmony default export */ var warning_notification = (WarningNotification);


/***/ }),

/***/ 65450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ analytics_data_stores; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/components/auth-switch/index.js + 15 modules
var auth_switch = __webpack_require__(17343);
// EXTERNAL MODULE: ./src/components/warning-notification/index.js + 1 modules
var warning_notification = __webpack_require__(42805);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var dist_index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./src/redux/action/stores.js
var action_stores = __webpack_require__(34372);
// EXTERNAL MODULE: ./src/redux/action/reportStatuses.js
var action_reportStatuses = __webpack_require__(41044);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/redux/reselect/stores.js
/* eslint-disable camelcase */ 

/* harmony default export */ var reselect_stores = ((0,reselect_es/* createSelector */.P1)(function(state) {
    return state.stores.payload;
}, function(payload) {
    var aggregations = payload.aggregations;
    if (!aggregations || !aggregations.results || !aggregations.results.buckets) return [];
    return aggregations.results.buckets.map(function(store) {
        return {
            key: store.key,
            name: store.key,
            itemTypes: (0,_to_consumable_array/* default */.Z)(store.item_type.buckets),
            orderTypes: (0,_to_consumable_array/* default */.Z)(store.order_type.buckets)
        };
    });
}));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/redux/reselect/config.js
var config = __webpack_require__(57708);
;// CONCATENATED MODULE: ./src/redux/reselect/reportStatuses.js
/* eslint-disable camelcase */ 




var selectStatusesData = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.reportStatuses.payload;
}, function(state, key) {
    return key;
}, function(payload, key) {
    return payload[key];
});
/* harmony default export */ var reselect_reportStatuses = ((0,reselect_es/* createSelector */.P1)(selectStatusesData, config/* default */.ZP, function(payload, param) {
    var languageCode = param.languageCode;
    moment_default().locale(languageCode);
    var data = payload === null || payload === void 0 ? void 0 : payload.data;
    if (!data || !data.length) return [];
    data.sort(function(a, b) {
        return moment_default()(a.date, "YYYY-MM-DD").format("YYYYMMDD") - moment_default()(b.date, "YYYY-MM-DD").format("YYYYMMDD");
    }).reverse();
    var maxDay = moment_default()(data[0].date, "YYYY-MM-DD").subtract(3, "day");
    return data.map(function(item) {
        var date = item.date;
        if (moment_default()(date, "YYYY-MM-DD").isAfter(maxDay)) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                lastDays: true
            });
        }
        return item;
    });
}));

// EXTERNAL MODULE: ./src/theme/card/index.js
var card = __webpack_require__(16850);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/item-type-card/index.js
var item_type_card = __webpack_require__(62396);
// EXTERNAL MODULE: ./src/theme/charts/colors.js
var colors = __webpack_require__(1778);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/theme/order-type-card/index.js
/* eslint-disable no-nested-ternary */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  border-radius: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0b94b9-0"
})(_templateObject(), dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
function OrderTypeCard(param) {
    var typeProp = param.type, style = param.style;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var type = typeProp === null || typeProp === void 0 ? void 0 : typeProp.toLowerCase();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        mt: "xs",
        px: "xs",
        py: "xxs",
        color: "white",
        bg: type === "rent" ? colors/* default.business_revenues.2 */.Z.business_revenues[2] : type === "buy" ? colors/* default.business_revenues.0 */.Z.business_revenues[0] : type === "refund" ? colors/* default.business_revenues.0 */.Z.business_revenues[0] : type === "lending" ? colors/* default.business_revenues.4 */.Z.business_revenues[4] : type === "free_download" ? colors/* default.business_revenues.4 */.Z.business_revenues[4] : type === "repartition_charge" ? colors/* default.business_revenues.5 */.Z.business_revenues[5] : type === "coupon" ? colors/* default.business_revenues.3 */.Z.business_revenues[3] : colors/* default.business_revenues.1 */.Z.business_revenues[1]
    }, style), {
        children: type === "rent" ? translations/* default */.Z[languageCode].libraries : type === "buy" ? "Retail" : type === "refund" ? translations/* default */.Z[languageCode].refund : type === "lending" ? "Lending" : type === "free_download" ? translations/* default */.Z[languageCode].free_download : type === "subscription" ? translations/* default */.Z[languageCode].subscription : type === "repartition_charge" ? translations/* default */.Z[languageCode]["sales breakdown"] : type === "coupon" ? "Coupon" : "Not defined"
    }));
}
/* harmony default export */ var order_type_card = (OrderTypeCard);

// EXTERNAL MODULE: ./src/theme/tooltip/index.js
var tooltip = __webpack_require__(4509);
// EXTERNAL MODULE: ./src/theme/icons/loader.js
var loader = __webpack_require__(39024);
// EXTERNAL MODULE: ./src/theme/alert-message/index.js
var alert_message = __webpack_require__(72846);
;// CONCATENATED MODULE: ./src/components/analytics/data-stores.js

function data_stores_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n"
    ]);
    data_stores_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 25px;\n  height: 25px;\n  animation: ",
        " 2s linear infinite;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 233px;\n\n  border-radius: 12px;\n\n  padding: 8px 16px;\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  width: 357px;\n\n  border: 1px solid;\n  box-sizing: border-box;\n  border-radius: 12px;\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


















var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a93ade4-0"
})(data_stores_templateObject(), dist_index_esm/* space */.Dh);
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a93ade4-1"
})(_templateObject1(), dist_index_esm/* flexbox */.GQ, dist_index_esm/* layout */.bK);
var Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a93ade4-2"
})(_templateObject2(), dist_index_esm/* flexbox */.GQ);
var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject3());
var WrapLoader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a93ade4-3"
})(_templateObject4(), rotate, (0,index_esm/* themeGet */.R)("colors.primary_500"));
var DataCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a93ade4-4"
})(_templateObject5(), dist_index_esm/* space */.Dh, dist_index_esm/* color */.$_, dist_index_esm/* border */.Cg);
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(theme_text/* default */.Z).withConfig({
    componentId: "sc-9a93ade4-5"
})(_templateObject6());
var StoreCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a93ade4-6"
})(_templateObject7(), dist_index_esm/* space */.Dh, dist_index_esm/* color */.$_, dist_index_esm/* border */.Cg);
function DataStoresAnalytics() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isWaiting = (0,es/* useSelector */.v9)(function(state) {
        return state.reportStatuses;
    }).isWaiting;
    var isWaitingStores = (0,es/* useSelector */.v9)(function(state) {
        return state.stores;
    }).isWaitingStores;
    var cacheKey = "CACHED";
    var stores = (0,es/* useSelector */.v9)(reselect_stores);
    var reportStatuses = (0,es/* useSelector */.v9)(function(state) {
        return reselect_reportStatuses(state, cacheKey);
    });
    (0,react.useEffect)(function() {
        dispatch((0,action_stores/* getStoresRequest */.eB)());
        dispatch((0,action_reportStatuses/* getReportStatusesRequest */.P3)({
            key: cacheKey
        }));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        p: "l",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                width: "100%",
                bg: "white",
                border: "none",
                p: "l",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "grey_600",
                                children: translations/* default */.Z[languageCode]["Data availability"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                ml: "xs",
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "medium",
                                color: "grey_600",
                                children: translations/* default */.Z[languageCode].Temporary
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        my: "m",
                        fontSize: "pLarge",
                        lineHeight: "pLarge",
                        fontWeight: "normal",
                        color: "grey_600",
                        children: translations/* default */.Z[languageCode].analytics_data_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                        flexDirection: "row",
                        flexWrap: "wrap",
                        children: isWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapLoader, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                                width: 25
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                !reportStatuses.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                    color: "grey_400",
                                    children: [
                                        "(",
                                        translations/* default */.Z[languageCode].analytics_no_data_description,
                                        ")"
                                    ]
                                }),
                                reportStatuses.map(function(report) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataCard, {
                                        m: "xs",
                                        bg: "primary_50",
                                        border: report.lastDays ? "2px solid" : "1px solid",
                                        borderColor: report.lastDays ? "primary_400" : "primary_200",
                                        "data-tip": true,
                                        "data-for": report.key,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                                fontSize: "pLarge",
                                                lineHeight: "pLarge",
                                                fontWeight: "bold",
                                                color: "grey_600",
                                                children: report.key
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                                forData: report.key,
                                                text: report.key,
                                                arrowColor: "#098EA0",
                                                backgroundColor: "#098EA0",
                                                place: "top",
                                                effect: "solid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                style: {
                                                    whiteSpace: "nowrap"
                                                },
                                                fontSize: "pSmall",
                                                lineHeight: "pSmall",
                                                fontWeight: report.lastDays ? "bold" : "medium",
                                                color: report.lastDays ? "primary_500" : "grey_600",
                                                children: report.date
                                            })
                                        ]
                                    }, report.key);
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                width: "100%",
                bg: "white",
                border: "none",
                p: "l",
                my: "s",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "grey_600",
                                children: translations/* default */.Z[languageCode]["Store availability"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                ml: "xs",
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "medium",
                                children: translations/* default */.Z[languageCode].Temporary
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                            width: "100%",
                            borderColor: "orange_400",
                            bg: "accent_light",
                            p: "m",
                            my: "s",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_message/* default */.Z, {
                                message: translations/* default */.Z[languageCode]["Fastbook Alert"]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        my: "m",
                        fontSize: "pLarge",
                        lineHeight: "pLarge",
                        fontWeight: "normal",
                        color: "grey_600",
                        children: translations/* default */.Z[languageCode].analytics_stores_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                        flexDirection: "row",
                        flexWrap: "wrap",
                        children: isWaitingStores ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapLoader, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                                width: 25
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: stores.map(function(store) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreCard, {
                                    m: "xs",
                                    bg: "primary_50",
                                    p: "s",
                                    borderColor: "primary_200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                            fontSize: "h3",
                                            lineHeight: "h3",
                                            fontWeight: "bold",
                                            color: "grey_600",
                                            children: store.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                            flexDirection: "column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                                    fontSize: "pLarge",
                                                    lineHeight: "pLarge",
                                                    fontWeight: "medium",
                                                    color: "grey_400",
                                                    mt: "xs",
                                                    children: translations/* default */.Z[languageCode].analytics_stores_itemTypes_label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                                    flexDirection: "row",
                                                    children: store.itemTypes.map(function(itemType) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(item_type_card/* default */.Z, {
                                                            type: itemType.key,
                                                            style: {
                                                                mr: "xs"
                                                            }
                                                        }, itemType.key);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                            flexDirection: "column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                                    fontSize: "pLarge",
                                                    lineHeight: "pLarge",
                                                    fontWeight: "medium",
                                                    color: "grey_400",
                                                    mt: "xs",
                                                    children: translations/* default */.Z[languageCode].analytics_stores_orderTypes_label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                                    flexDirection: "row",
                                                    children: store.orderTypes.map(function(orderType) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(order_type_card, {
                                                            type: orderType.key,
                                                            style: {
                                                                mr: "xs"
                                                            }
                                                        }, orderType.key);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, store.key);
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var data_stores = (DataStoresAnalytics);

// EXTERNAL MODULE: ./src/theme/header/index.js + 1 modules
var header = __webpack_require__(28116);
// EXTERNAL MODULE: ./src/theme/layouts/body.js
var body = __webpack_require__(89129);
// EXTERNAL MODULE: ./src/components/top-bar/index.js
var top_bar = __webpack_require__(32095);
// EXTERNAL MODULE: ./src/components/analytics/analytics-sub-menu.js
var analytics_sub_menu = __webpack_require__(58562);
;// CONCATENATED MODULE: ./src/pages/analytics/data-stores/index.js

function analytics_data_stores_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px ",
        "px 0;\n"
    ]);
    analytics_data_stores_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var StyledWarningNotification = (0,styled_components_browser_esm/* default */.ZP)(warning_notification/* default */.Z).withConfig({
    componentId: "sc-cd98f544-0"
})(analytics_data_stores_templateObject(), (0,index_esm/* themeGet */.R)("space.l"), (0,index_esm/* themeGet */.R)("space.l"));
function AnalyticPage() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(auth_switch/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(body/* default */.Z, {
                bg: "primary_50",
                height: "100%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                bg: "white",
                title: "StreetLib Analytics",
                style: {
                    bg: "white",
                    borderWidth: "0",
                    borderBottomWidth: "1px",
                    borderColor: "primary_200",
                    borderStyle: "solid"
                },
                componentLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    ml: [
                        0,
                        "l",
                        "l",
                        "l"
                    ],
                    fontSize: [
                        "h3",
                        "h2",
                        "h2",
                        "h2"
                    ],
                    lineHeight: [
                        "h3",
                        "h2",
                        "h2",
                        "h2"
                    ],
                    fontWeight: "bold",
                    color: "grey_600",
                    textAlign: "left",
                    children: translations/* default */.Z[languageCode].analytics
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(analytics_sub_menu/* default */.Z, {
                activeKey: "data-stores"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWarningNotification, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(data_stores, {})
        ]
    });
}
/* harmony default export */ var analytics_data_stores = (AnalyticPage);


/***/ }),

/***/ 45257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57708);
/* eslint-disable camelcase */ 






/* harmony default export */ __webpack_exports__["Z"] = ((0,reselect__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.filters;
}, function(state) {
    return state.profile;
}, _config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, function(payload, profile, param) {
    var formatDate = param.formatDate;
    var dates = payload.dates, others = payload.others, terms = payload.terms, dataType = payload.dataType, includeRepartitionCharge = payload.includeRepartitionCharge, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(payload, [
        "dates",
        "others",
        "terms",
        "dataType",
        "includeRepartitionCharge"
    ]);
    var analytics_type = profile.payload.analytics_type;
    // Funzione per pulire i dati e rimuovere riferimenti circolari
    // Only store type, label, color - value and isExclusive are derived from filters/terms
    var cleanFilterData = function(filter) {
        return {
            type: String(filter.type || ""),
            label: String(filter.label || ""),
            color: String(filter.color || "")
        };
    };
    // Estraggo tipo e valore da filter.value (es. "store_id=44"). Salto le entry
    // malformate o prive di value (può capitare con stati persistiti vecchi o
    // ricostruiti da query string) per evitare crash su .split di undefined.
    var buildFilterString = function(collection) {
        return Object.keys(collection).map(function(key) {
            var item = collection[key];
            if (!item || typeof item.value !== "string" || !item.value.includes("=")) return null;
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(item.value.split("="), 2), itemType = ref[0], itemValue = ref[1];
            var prefix = item.isExclusive ? "-" : "";
            return "".concat(itemType, "=").concat(prefix).concat(itemValue);
        }).filter(Boolean).join(",");
    };
    var othersToString = buildFilterString(others);
    var termsToString = buildFilterString(terms);
    var repartitionsFilter;
    var hasPublisher = Object.keys(others).some(function(key) {
        return key.includes("publisher");
    });
    if (hasPublisher) repartitionsFilter = "document_source_type=-repartition_credit";
    if (!includeRepartitionCharge) {
        repartitionsFilter = "document_source_type=-repartition_charge,document_source_type=-repartition_credit";
    }
    if (repartitionsFilter) {
        if (termsToString.length) termsToString = "".concat(termsToString, ",").concat(repartitionsFilter);
        else termsToString = repartitionsFilter;
    }
    // Pulisco i dati dei filtri per evitare problemi di serializzazione JSON
    var cleanFiltersData = Object.keys(others).reduce(function(acc, key) {
        try {
            acc[key] = cleanFilterData(others[key]);
        } catch (error) {
            // Se c'è un errore, creo un filtro pulito di fallback
            acc[key] = cleanFilterData({
                type: "unknown",
                label: "Unknown",
                color: "black"
            });
        }
        return acc;
    }, {});
    var cleanTermsData = Object.keys(terms).reduce(function(acc, key) {
        try {
            acc[key] = cleanFilterData(terms[key]);
        } catch (error) {
            // Se c'è un errore, creo un termine pulito di fallback
            acc[key] = cleanFilterData({
                type: "unknown",
                label: "Unknown",
                color: "black"
            });
        }
        return acc;
    }, {});
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        dataType: dataType === "aggregated_data" && (analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/)) ? "temporary_data" : dataType,
        dateFrom: moment__WEBPACK_IMPORTED_MODULE_0___default()(dates[0]).format(formatDate),
        dateTo: moment__WEBPACK_IMPORTED_MODULE_0___default()(dates[1]).format(formatDate),
        filters: othersToString,
        terms: termsToString,
        filtersData: JSON.stringify(cleanFiltersData),
        termsData: JSON.stringify(cleanTermsData)
    });
}));


/***/ }),

/***/ 72846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5799);
/* harmony import */ var theme_icons_alert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88176);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n\n  & > span {\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-acd3e5bb-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.warning"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_);
function AlertMessage(param) {
    var message = param.message, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, style), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_alert__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                fontSize: "h4",
                lineHeight: "h4",
                fontWeight: "medium",
                color: "grey_600",
                ml: "xs",
                children: message
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (AlertMessage);


/***/ }),

/***/ 1778:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    item_type: {
        0: "blue_500",
        1: "blue_400",
        2: "blue_300"
    },
    business_revenues: {
        0: "pie_1_0",
        1: "pie_1_1",
        2: "pie_1_2",
        3: "grey_400",
        4: "pie_1_3",
        5: "primary_200"
    },
    store_name: {
        0: "pie_0_0",
        1: "pie_0_1",
        2: "pie_0_2",
        3: "pie_0_3",
        4: "pie_0_4",
        5: "pie_0_5"
    },
    title: {
        0: "pie_1_0",
        1: "pie_1_1",
        2: "pie_1_2",
        3: "pie_1_3",
        4: "pie_1_4",
        5: "pie_1_5"
    },
    main_category: {
        0: "pie_2_0",
        1: "pie_2_1",
        2: "pie_2_2",
        3: "pie_2_3",
        4: "pie_2_4",
        5: "pie_2_5"
    }
});


/***/ }),

/***/ 62396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* eslint-disable no-nested-ternary */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  border-radius: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Label = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-86ccd567-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
function ItemTypeCard(param) {
    var type = param.type, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        mt: "xs",
        px: "xs",
        py: "xxs",
        color: "white",
        bg: type === "ebook" ? "blue_400" : type === "audiobook" ? "blue_500" : "blue_300"
    }, style), {
        children: type
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ItemTypeCard);


/***/ }),

/***/ 66084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5799);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n\n  & > a {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 2px;\n  height: 34px; /* Altezza adeguata per stare tra i bottoni */\n  background-color: ",
        ";\n  margin: 0 8px; /* Spazio tra gli elementi */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var TabBtn = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-c093c216-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var HorizontalDivider = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-2"
})(_templateObject2(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"));
function SubMenu(param) {
    var activeKey = param.activeKey, options = param.options;
    var isConfirmed = options.length > 0 && options[1].key === "confirmed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        py: "s",
        px: "l",
        children: options.map(function(option, index) {
            var isSecondWithOnClick = index === 1 && option.onClick;
            var nextOptionExists = index < options.length - 1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    !option.onClick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: option.href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "link",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                                type: "button",
                                py: "s",
                                px: "m",
                                bg: activeKey === option.key ? "primary_100" : "transparent",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    fontSize: "h3",
                                    lineHeight: "h3",
                                    fontWeight: "medium",
                                    color: activeKey === option.key ? "primary_500" : option.color ? option.color : "grey_400",
                                    textAlign: "center",
                                    children: option.title
                                })
                            })
                        })
                    }, option.key) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                        type: "button",
                        py: "s",
                        px: "m",
                        bg: activeKey === option.key ? "primary_100" : (option === null || option === void 0 ? void 0 : option.bgColor) ? option === null || option === void 0 ? void 0 : option.bgColor : "transparent",
                        onClick: option.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "medium",
                            color: activeKey === option.key ? "primary_500" : (option === null || option === void 0 ? void 0 : option.color) ? option === null || option === void 0 ? void 0 : option.color : "grey_400",
                            textAlign: "center",
                            children: option.title
                        })
                    }),
                    isSecondWithOnClick && nextOptionExists && isConfirmed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalDivider, {})
                ]
            }, option.key);
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SubMenu);


/***/ }),

/***/ 4509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24762);






function CustomTooltip(_param) {
    var text = _param.text, forData = _param.forData, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "forData"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: forData,
        "aria-haspopup": "true"
    }, others), {
        children: text
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (CustomTooltip);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3092,1664,8098,4762,6535,7343,9774,2888,179], function() { return __webpack_exec__(78299); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);